if (!customElements.get('adev-review-carousel')) {
    customElements.define('adev-review-carousel', class adevReviewCarousel extends HTMLElement {
        constructor() {
            super();

            this.carouselEl = this.querySelector('[data-adev-review-carousel="carousel"]');
        }
        
        shopifyCustomizerInit() {
            if (!Shopify.designMode) return;

            document.addEventListener('shopify:block:select', (event) => {
                const blockId = event.detail.blockId;
                const blockEl = this.querySelector(`[data-adev-review-carousel="carousel-item"][data-block-id="${blockId}"]`);
                
                if (blockEl) {
                    const index = parseInt(blockEl.getAttribute('data-index'), 10);
                    if (this._slider) {
                        this._slider.select(index);
                    }
                }

            });
        }
        
        initSlider(){

            const getCellAlign = () => window.innerWidth < 768 ? 'center' : 'left';

            const getInitialIndex = () => window.innerWidth < 768 ? 1 : 0;

            this._slider = new Flickity(this.carouselEl, {
                cellAlign: getCellAlign(),
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                initialIndex: getInitialIndex()
            });

            this._onResize = () => {
                const align = getCellAlign();
                this._slider.options.cellAlign = align;
                this._slider.options.initialIndex = getInitialIndex();
                this._slider.resize();
                this._slider.positionCells();
                this._slider.select(this._slider.selectedIndex, false, true);
            };

            window.addEventListener('resize', this._onResize);

            const prevEl = this.querySelector('[data-adev-review-carousel="carousel-prev"]');
            const nextEl = this.querySelector('[data-adev-review-carousel="carousel-next"]');
            if (prevEl && nextEl) {

                prevEl.addEventListener('click', () => {
                    this._slider.previous();
                });

                nextEl.addEventListener('click', () => {
                    this._slider.next();
                });
            }
        }

        destroySlider(){
            if(this._slider){
                this._slider.destroy();
            }
            
            if (this._onResize) {
                window.removeEventListener('resize', this._onResize);
                this._onResize = null;
            }
        }

        connectedCallback() {
            this.initSlider();
            this.shopifyCustomizerInit();
        }

        disconnectedCallback() {
            this.destroySlider();
        }

    });
}